import React, { useState, useEffect } from 'react';
import { Typography, Spin } from 'antd';
import axios from 'axios';

const { Link } = Typography;

const AutoLink = ({ url }) => {
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTitle = async () => {
      try {
        const response = await axios.get(url);
        const html = response.data;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const pageTitle = doc.querySelector('title')?.innerText;
        if(pageTitle) setTitle(pageTitle);
        else setTitle(url);
      } catch (error) {
        setTitle(url);
      } finally {
        setLoading(false);
      }
    };

    fetchTitle();
  }, [url]);

  return (
    <Link href={url} target="_blank">
      {loading ? <Spin /> : title}
    </Link>
  );
};

export default AutoLink;